import { useState } from "react";
import Navbar from "./components/Navbar";
import SortingVisualizer from "./components/SortingVisualizer";

function App() {
  const [algorithm, setAlgorithm] = useState("bubble");

  return (
    <div className="App">
      <Navbar setAlgorithm={setAlgorithm} />
      <SortingVisualizer algorithm={algorithm} />
    </div>
  );
}

export default App;